import React from 'react';
import './EmergencyWidget.css';
import templates from './templates';

export const EmergencyWidget = ({
  initialData,
  template = 'List',
  title = 'חירום והצלה',
  showTitle = true,
  columns,
  onSave
}) => {
  // וידוא שהנתונים מוגדרים כראוי
  const safeData = {
    volunteers: {
      medic: initialData?.volunteers?.medic || [],
      paramedic: initialData?.volunteers?.paramedic || [],
      maar: initialData?.volunteers?.maar || []
    }
  };

  const TemplateComponent = templates[template] || templates.List;

  return (
    <TemplateComponent
      initialData={safeData}
      title={title}
      showTitle={showTitle}
      columns={columns}
      onSave={onSave}
    />
  );
};